export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_ID_SELLER = 'SET_ID_SELLER';
export const SET_USER_NAME = 'SET_USER_NAME';
export const SET_USER_CREDENTIALS = 'SET_USER_CREDENTIALS';
export const SET_MFA_STATUS = 'SET_MFA_STATUS';
// UTILIZAR ESTA CONVENCIÓN PARA REDUCIR LARGO DE CONST
export const SIDEBAR = {
    SET_HIDDEN_ITEMS: "SET_HIDDEN_ITEMS"
}

export const LOADING_PUBLICACIONES = 'LOADING_PUBLICACIONES';
export const FETCH_PUBLICACIONES = 'FETCH_PUBLICACIONES';
export const FETCH_PUBLICACION = 'FETCH_PUBLICACION';
export const FETCH_IMAGENES_PUBLICACION = 'FETCH_IMAGENES_PUBLICACION';
export const EDIT_PUBLICACION = 'EDIT_PUBLICACION';
export const FETCH_TIPOPUBLICACION = 'FETCH_TIPOPUBLICACION'
export const IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB = 'IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB'
export const FETCH_ESTADOSVARIACIONES = 'FETCH_ESTADOSVARIACIONES';
export const FETCH_MARCAS = 'FETCH_MARCAS';
export const FETCH_DIMENSIONES = 'FETCH_DIMENSIONES';
export const FETCH_CATEGORIAS = 'FETCH_CATEGORIAS';
export const FETCH_MOTIVOS = 'FETCH_MOTIVOS';
export const SET_FILTRO_PUBLICACIONES = 'SET_FILTRO_PUBLICACIONES';
export const SE_MODIFICARON_IMAGENES = 'SE_MODIFICARON_IMAGENES';
export const FETCH_GARANTIAS = 'FETCH_GARANTIAS';
export const LOADING_GARANTIAS = 'LOADING_GARANTIAS';
export const FETCH_DASHBOARD = 'FETCH_DASHBOARD';
export const LOADING_DASHBOARD = 'LOADING_DASHBOARD';
export const SET_FILTRO_DASHBOARD = 'SET_FILTRO_DASHBOARD';
export const SET_IMAGES_UPLOADER = 'SET_IMAGES_UPLOADER';
export const HAY_CAMBIOS_EN_IMAGENES = 'HAY_CAMBIOS_EN_IMAGENES';
export const UPDATE_PUBLICACIONES_LIST = 'UPDATE_PUBLICACIONES_LIST';
export const RESET_MARCA_Y_CATEGORIA = 'RESET_MARCA_Y_CATEGORIA';
export const RESET_LIST_PUBLICACIONES = 'RESET_LIST_PUBLICACIONES';
export const SET_PERCEPCION_RETENCION = "SET_PERCEPCION_RETENCION";
export const FETCH_ALICUOTA_IVA = 'FETCH_ALICUOTA_IVA';
export const LOADING_DETALLE_RETENCIONES = 'LOADING_DETALLE_RETENCIONES';

// Borrar estos dos
export const FETCH_ATRIBUTOS_CATEGORIA = 'FETCH_ATRIBUTOS_CATEGORIA';
export const FETCH_ATRIBUTOS_POR_PUBLICACION = 'FETCH_ATRIBUTOS_POR_PUBLICACION';


export const FETCH_ATRIBUTOSCATEGORIA = 'FETCH_ATRIBUTOSCATEGORIA';
export const FETCH_ATRIBUTOSCATEGORIAAGRUPAMIENTO = 'FETCH_ATRIBUTOSCATEGORIAAGRUPAMIENTO';
export const FETCH_VALORESATRIBUTO = 'FETCH_VALORESATRIBUTO';
export const FETCH_ESTRUCTURAATRIBUTOSVALORES = 'FETCH_ESTRUCTURAATRIBUTOSVALORES';
export const FETCH_AGRUPAMIENTOS = 'FETCH_AGRUPAMIENTOS';
export const SET_ESTRUCTURAATRIBUTOSVALORES = 'SET_ESTRUCTURAATRIBUTOSVALORES';
export const SET_PRODUCTOVALORES = 'SET_PRODUCTOVALORES';
export const SET_HUBO_CAMBIOS_ESTRUCTURA_ATRIBUTOS = 'SET_HUBO_CAMBIOS_ESTRUCTURA_ATRIBUTOS';


export const LOADING_NOTIFICACIONES = 'LOADING_NOTIFICACIONES';
export const CHANGE_TAB_ACTIVA_NOTIFICACIONES = 'CHANGE_TAB_ACTIVA_NOTIFICACIONES';
export const FETCH_TOTAL_NOTIFICACIONES = 'FETCH_TOTAL_NOTIFICACIONES';
export const FETCH_DETALLE_NOTIFICACIONES = 'FETCH_DETALLE_NOTIFICACIONES';
export const FETCH_LEIDAS_NOTIFICACIONES = 'FETCH_LEIDAS_NOTIFICACIONES';
export const FETCH_AJUSTES_NOTIFICACIONES = 'FETCH_AJUSTES_NOTIFICACIONES';
export const FETCH_STOCK = 'FETCH_STOCK';

export const FETCH_ORDENES = 'FETCH_ORDENES';
export const FETCH_ORDENES_ENCABEZADO = 'FETCH_ORDENES_ENCABEZADO';
export const RESET_ORDENES = 'RESET_ORDENES'
export const FETCH_ORDENES_EN_VERDE = 'FETCH_ORDENES_EN_VERDE';
export const FETCH_ORDENES_TELEFONICAS = 'FETCH_ORDENES_TELEFONICAS';
export const LOADING_ORDENES = 'LOADING_ORDENES';
export const FETCH_ORDEN = 'FETCH_ORDEN';
export const EDIT_ORDEN = 'EDIT_ORDEN';
export const FETCH_CLIENTE = 'FETCH_CLIENTE';

export const FETCH_SELLERS = 'FETCH_SELLERS';
export const FETCH_SELLER = 'FETCH_SELLER';
export const EDIT_SELLER = 'EDIT_SELLER';
export const FETCH_SELLERS_FILTER = 'FETCH_SELLERS_FILTER';
export const SET_FILTRO_SELLER = 'SET_FILTRO_SELLER';
export const LOADING_SELLERS = 'LOADING_SELLERS';
export const RESET_SELLERS = 'RESET_SELLERS';
export const UPDATE_SELLERS_LIST = 'UPDATE_SELLERS_LIST';
export const FETCH_PROVINCIAS_LOCALIDADES = 'FETCH_PROVINCIAS_LOCALIDADES';
export const CLEAR_LOCALIDAD_PROVINCIA = 'CLEAR_LOCALIDAD_PROVINCIA';

export const FETCH_INTEGRADORES = 'FETCH_INTEGRADORES';
export const FETCH_FACTURACIONES = 'FETCH_FACTURACIONES';
export const SET_FILTRO_ORDENES = 'SET_FILTRO_ORDENES';
export const LIMPIAR_FILTRO = 'LIMPIAR_FILTRO';
export const RESET_FILTRO_TIPOS_PUBLICACION = 'RESET_FILTRO_TIPOS_PUBLICACION';
export const SET_FILTRO_TIPOS_PUBLICACION = 'SET_FILTRO_TIPOS_PUBLICACION';
export const RESET_SET_TIPO_PUBLICACIONES = 'RESET_SET_TIPO_PUBLICACIONES'
export const UPDATE_PUBLICACIONES_ESTADO = 'UPDATE_PUBLICACIONES_ESTADO'
export const RESET_TIPOS_PUBLICACION = 'RESET_TIPOS_PUBLICACION';
export const RESET_VALUE_CHECKED = 'RESET_VALUE_CHECKED'
export const RESET_ID_ESTADO_LIQUIDACION = 'RESET_ID_ESTADO_LIQUIDACION'

export const LOADING_USUARIOS = 'LOADING_USUARIOS';
export const EDIT_USUARIO = 'EDIT_USUARIO';
export const SET_USER_ID = 'SET_USER_ID';
export const FETCH_USUARIOS = 'FETCH_USUARIOS';
export const FETCH_USUARIO = 'FETCH_USUARIO';
export const SET_FILTRO_USUARIOS = 'SET_FILTRO_USUARIOS';
export const RESET_FILTRO_USUARIO = 'RESET_FILTRO_USUARIO'
export const UPDATE_LIST_USUARIOS = 'UPDATE_LIST_USUARIOS';
export const FETCH_TOKEN_RESET_PASSWORD = 'FETCH_TOKEN_RESET_PASSWORD';
export const RESET_USUARIO = 'RESET_USUARIO';
export const CHAT_NEW_REQUEST = 'CHAT_NEW_REQUEST';
export const CHAT_REQUEST_ACCEPTED = 'CHAT_REQUEST_ACCEPTED';
export const CHAT_CLEAR_REQUEST = 'CHAT_CLEAR_REQUEST';
export const CHAT_CANCEL_REQUEST = 'CHAT_CANCEL_REQUEST';
export const SET_CHAT_CONNECTION_ID = 'SET_CHAT_CONNECTION_ID';
export const FETCH_TIPOS_USUARIOS = 'FETCH_TIPOS_USUARIOS';
export const FETCH_ACCIONES_TIPO_USUARIO = 'FETCH_ACCIONES_TIPO_USUARIO';
export const FETCH_ACCIONES = 'FETCH_ACCIONES';

export const LOADING_PLANES = 'LOADING_PLANES';
export const SET_PLANES = 'SET_PLANES';
export const SET_PLANES_DESDE_BUSQUEDA = 'SET_PLANES_DESDE_BUSQUEDA';
export const FETCH_GRUPO_PLANES = 'FETCH_GRUPO_PLANES';
export const FETCH_GRUPO_PLANES_BYID = 'FETCH_GRUPO_PLANES_BYID';
export const FETCH_GRUPO_BYID = 'FETCH_GRUPO_BYID';
export const SET_DATA_GRUPO = 'SET_DATA_GRUPO';
export const SET_DATA_GRUPO_COPY = 'SET_DATA_GRUPO_COPY';
export const SET_GRUPO_PLANES = 'SET_GRUPO_PLANES';
export const SET_TIPOS_GRUPO_PLANES = 'SET_TIPOS_GRUPO_PLANES';
export const SET_FILTRO_GRUPO_PLANES = 'SET_FILTRO_GRUPO_PLANES';
export const RESET_GRUPO_PLANES = 'RESET_GRUPO_PLANES';
export const UPDATE_GRUPO_PLANES_LIST = 'UPDATE_GRUPO_PLANES_LIST';

export const LOADING_TIPOS_PUBLICACION = 'LOADING_TIPOS_PUBLICACION';
export const FETCH_TIPOS_PUBLICACION = 'FETCH_TIPOS_PUBLICACION';
export const FETCH_PROVEEDORES_FILTER = 'FETCH_PROVEEDORES_FILTER';
export const SET_TIPOS_PUBLICACION = 'SET_TIPOS_PUBLICACION';
export const SET_ID = 'SET_ID';
export const FETCH_TIPOS_PUBLICACION_BYID = 'FETCH_TIPOS_PUBLICACION_BYID';
export const UPDATE_LIST_TIPOS_PUBLICACIONES = 'UPDATE_LIST_TIPOS_PUBLICACIONES';

export const EDITANDO = 'EDITANDO';
export const RESET_OBJECT = 'RESET_OBJECT';
export const SET_OBJECT = 'SET_OBJECT';

export const FETCH_SITUACION_IVA = 'FETCH_SITUACION_IVA';
export const FETCH_LOCALIDADES = 'FETCH_LOCALIDADES';
export const FETCH_PLANES_BYPARAMS = 'FETCH_PLANES_BYPARAMS';
export const FETCH_TIPOS_ADQUIRIENTES = 'FETCH_TIPOS_ADQUIRIENTES';
export const FETCH_TIPOS_SEXO = 'FETCH_TIPOS_SEXO';

export const LOADING_LIQUIDACIONES = 'LOADING_LIQUIDACIONES';
export const LOADING_ORDENES_LIQUIDACION = 'LOADING_ORDENES_LIQUIDACION';
export const LOADING_NOVEDADES_LIQUIDACION = 'LOADING_NOVEDADES_LIQUIDACION';
export const LOADING_LOGISTICA_LIQUIDACION = 'LOADING_LOGISTICA_LIQUIDACION';
export const FETCH_LIQUIDACIONES_LISTA_SELLERS = 'FETCH_LIQUIDACIONES_LISTA_SELLERS';
export const FETCH_LIQUIDACIONES_BUSQUEDA = 'FETCH_LIQUIDACIONES_BUSQUEDA';
export const FETCH_LIQUIDACION_POR_ID = 'FETCH_LIQUIDACION_POR_ID';
export const FETCH_LIQUIDACION_POR_ID_ORDENES = 'FETCH_LIQUIDACION_POR_ID_ORDENES';
export const FETCH_LIQUIDACION_POR_ID_NOVEDADES = 'FETCH_LIQUIDACION_POR_ID_NOVEDADES';
export const FETCH_LIQUIDACION_POR_ID_LOGISTICA = 'FETCH_LIQUIDACION_POR_ID_LOGISTICA';
export const SET_FILTRO_LIQUIDACIONES = 'SET_FILTRO_LIQUIDACIONES';
export const RESET_FILTRO_LIQUIDACIONES = 'RESET_FILTRO_LIQUIDACIONES'
export const RESET_LIQUIDACIONES = 'RESET_LIQUIDACIONES'
export const UPDATE_LIST_LIQUIDACIONES = 'UPDATE_LIST_LIQUIDACIONES'
export const UPDATE_ESTADO_LIQUIDACION = 'UPDATE_ESTADO_LIQUIDACION'
export const FETCH_DETALLE_RETENCIONES = 'FETCH_DETALLE_RETENCIONES';
export const FETCH_DETALLE_PERCEPCIONES = 'FETCH_DETALLE_PERCEPCIONES';
export const RESET_PERCEPCION_RETENCION_LIQUIDACION = 'RESET_PERCEPCION_RETENCION_LIQUIDACION';
export const UPDATE_CUERPO_ORDENES_LIQUIDACION = 'UPDATE_CUERPO_ORDENES_LIQUIDACION';
export const LOADING_DETALLE_LIQUIDACION = 'LOADING_DETALLE_LIQUIDACION';
export const CLEAR_LOGISTICA_FOR_SELLER = 'CLEAR_LOGISTICA_FOR_SELLER';

export const FETCH_TIPOS_CONCEPTOS = 'FETCH_TIPOS_CONCEPTOS';
export const LOADING_TIPOS_CONCEPTOS = 'LOADING_TIPOS_CONCEPTOS';
export const CREAR_NOVEDAD_LIQUIDACION = 'CREAR_NOVEDAD_LIQUIDACION';
export const FETCH_ACCIONES_LIQUIDACIONES = 'FETCH_ACCIONES_LIQUIDACIONES';
export const FETCH_ACCION_LIQUIDACION_COMBO = 'FETCH_ACCION_LIQUIDACION_COMBO';
export const FETCH_ESTADOS_LIQUIDACIONES = 'FETCH_ESTADOS_LIQUIDACIONES';
export const FETCH_RESULTADOS_LIQUIDACIONES = 'FETCH_RESULTADOS_LIQUIDACIONES';
export const FETCH_ORDENES_PARA_NUEVA_LIQUIDACION = 'FETCH_ORDENES_PARA_NUEVA_LIQUIDACION';
export const FETCH_NOVEDADES_PARA_NUEVA_LIQUIDACION = 'FETCH_NOVEDADES_PARA_NUEVA_LIQUIDACION';
export const LIMPIAR_LIQUIDACIONES_BUSQUEDA = 'LIMPIAR_LIQUIDACIONES_BUSQUEDA';


export const LOADING_REBATES = 'LOADING_REBATES';
export const SET_FILTRO_REBATES = 'SET_FILTRO_REBATES';
export const FETCH_REBATES = 'FETCH_REBATES';
export const FETCH_REBATE = 'FETCH_REBATE';
export const EDIT_REBATE = 'EDIT_REBATE';
export const RESET_REBATES = 'RESET_REBATES'

export const RESET_PUBLICACIONES = 'RESET_PUBLICACIONES';
export const SET_LIMPIAR_FILTRO_TIPOS_PUBLICACION = 'SET_LIMPIAR_FILTRO_TIPOS_PUBLICACION';


export const SET_ID_GRUPO_PLAN = 'SET_ID_GRUPO_PLAN';

export const SET_EDITANDO = 'SET_EDITANDO';

export const FETCH_LOGISTICA_PROPIA = 'FETCH_LOGISTICA_PROPIA';
export const SET_LOGISTICA_PROPIA = 'SET_LOGISTICA_PROPIA';
export const SET_LOGISTICA_CACHE = 'SET_LOGISTICA_CACHE';
export const SET_LOGISTICA_DIRTY = 'SET_LOGISTICA_DIRTY';

export const RESET_FAQS = 'RESET_FAQS'
export const FETCH_TOTALIZADORES_TARJETA = 'FETCH_TOTALIZADORES_TARJETA';
export const FETCH_RESUMEN_ESTADOS = 'FETCH_RESUMEN_ESTADOS';
export const FETCH_TOP_PRODUCTOS = 'FETCH_TOP_PRODUCTOS';
export const FETCH_TOP_CATEGORIAS = ' FETCH_TOP_CATEGORIAS';
export const FETCH_TOP_TIPO_PUBLICACIONES = 'FETCH_TOP_TIPO_PUBLICACIONES';
